/**
 * Copyright IBM Corp. 2016, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

var useIsomorphicEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;

exports["default"] = useIsomorphicEffect;
